import { render, staticRenderFns } from "./renamer.vue?vue&type=template&id=3fd6e327&"
import script from "./renamer.vue?vue&type=script&lang=js&"
export * from "./renamer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports